export default __webpack_public_path__ + "static/media/cameraIcon.caec365b.webp";